import { render, staticRenderFns } from "./Pen.vue?vue&type=template&id=e48195e2&scoped=true&"
var script = {}
import style0 from "./Pen.vue?vue&type=style&index=0&id=e48195e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48195e2",
  null
  
)

export default component.exports